import { useNavigate, useParams } from "react-router-dom";
import NavBar from "../Componentes/NavBar";
import GenericBody from "../Componentes/GenericBody";
import RacBody from "../Componentes/RAC/RacBody";
import Overlay from "../Componentes/Overlay";
import { useEffect, useState } from "react";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import RacForm from "../Componentes/RAC/RacForm";
import axios from "axios";
import { ToastContainer } from 'react-toastify';

const RAC = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [racs, setRacs] = useState([]);

    const [sidebar, setSidebar] = useState(false);
    const [overForm, setOverForm] = useState(false);

    const getValues = async () => {

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/RAC/GetRacs/')

            setRacs(data);

        } catch (error) {

            console.error(error);

        }

    }

    useEffect(() => {

        getValues();

    }, [])

    const openSideBar = () => {

        setSidebar(true);

    }

    const closeSideBar = () => {

        setSidebar(false);

    }

    const openForm = () => {

        setSidebar(false);
        setOverForm(true);

    }

    const closeForm = () => {

        setOverForm(false);
        navigate("/modulo/ssma/rac/");

    }

    const updateId = ( id ) => {

        navigate(`./${ id }`);

    }

    return (
        <>
            <NavBar
                title="RAC's"
                goBackOnePage
                setSideBar={openSideBar}
            />
            <GenericBody>
                <RacBody
                    racs={racs}
                    openEdit={updateId}
                    onRacDeleted={getValues}
                />
            </GenericBody>

            {(id || overForm) &&
                <Overlay
                    state={true}
                >
                    <RacForm
                        closeForm={closeForm}
                        updateItens={getValues}
                    />
                </Overlay>}

            {
                sidebar &&
                <Overlay
                    state={true}
                    changeContent={closeSideBar}
                >
                    <SideMenu>
                        <SideMenuBtn
                            button="NOVA RAC"
                            clickFunc={openForm}
                        />
                    </SideMenu>

                </Overlay>
            }

            <ToastContainer
                style={{
                    zIndex: 99999
                }}
                autoClose={3000}
                position="top-center"
                theme="dark"
            />

        </>
    )

}

export default RAC;